import React from 'react';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const HelpModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="help-modal-overlay" onClick={onClose}>
      <div className="help-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="help-modal-header">
          <h2>{t('tips.title')}</h2>
          <button 
            className="help-modal-close" 
            onClick={onClose}
            aria-label={t('buttons.closeTips')}
          >
            <X size={20} />
          </button>
        </div>
        
        <div className="help-modal-body">
          <ul className="help-tips-list">
            <li>{t('tips.selectLocations')}</li>
            <li>
              {t('tips.copyPaste', { key: '⌘', key2: 'C' })}
            </li>
            <li>
              {t('tips.sendGmail', { key: '⌘', key2: 'G' })}
            </li>
            <li>
              {t('tips.createCalendar', { key: '⌘', key2: 'M' })}
            </li>
            <li>
              {t('tips.downloadICal', { key: '⌘', key2: 'I' })}
            </li>
            <li>
              {t('tips.setHome')}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HelpModal;